<script>
    import { _ } from 'svelte-i18n';
    import { url } from '../stores/url.js';
    import { view_width } from '../stores/view_width.js';     
    import { user } from '../stores/user.js';
    import { users } from '../stores/users.js';
    import { date, getLocation, hhmm, padNumber, successNotification, swalConfirm, warningNotification } from '../functions/html-helpers';
    import { getUsers, request } from '../functions/http-helpers.js';
    import { onMount } from 'svelte';
    import UserDayTime from '../components/UserDayTime.svelte'
    import Map from '../components/Map.svelte'
    import uikit from 'uikit';
 
      
 

    /* SETUP */  
    let gudocm = null; 
    const now = new Date();
    const yesterday = new Date(); 
    yesterday.setDate(now.getDate() - 1);
    let bv_date = date('Y-m-d', now);
    let user_month_days = [];     
    let admin_overview_loaded = false;

    let user_id = '';
    let bv_user_nr = '';
    let bv_firstname = '';
    let bv_lastname = '';

    let contract_id = '';
    let bv_contract_start = '';
    let bv_contract_end = '';
    let bv_default_break = '';
    let bv_monthly_hours = '';
    let bv_dayli_hours = '';
    let bv_yearly_holidays = '';
    let bv_start_holidays = '';
    let bv_start_overtime = '';
    let bv_holiday_hours = '';
    
    let day_id = '';
    let day_date = '';
    let day_user_id = '';
    let bv_day_vacation = false;
    let bv_day_case = '';
    let bv_day_faz = false;
    let bv_without_break = false;
    let start_stamp = ''; 
    let end_stamp = '';
    let bv_time_clocked_in = '';
    let bv_time_clocked_out = '';
    let bv_start_location = '';
    let bv_end_location = '';
    let bv_time_clocked_in2 = '';
    let bv_time_clocked_out2 = '';
    let bv_start_location2 = '';
    let bv_end_location2 = '';
    let bv_day_note = '';
    let bv_start_work = '';
    let bv_end_work = '';
    let bv_clicked_date = '';

    let edit_user_month_id = '';
    let bv_additional_holidays = '';
    let bv_overtime_hours_payed_out = '';

    let bv_selected_user = $user?.id ?? ''; 
    
    onMount(() => {
        uikit.tooltip('[data-uk-tooltip]');
    });
    // getUsersWithMonthDays();
    


    /* WATCH */
    $: daysOfMonth = getDatesOfCurrentMonth(bv_date);
    $: getUserDaysOfCurrentMonth(daysOfMonth);
    $: getUsersWithMonthDays(daysOfMonth);
    $: workedMinutes = calcWorkedMinutes(user_month_days);
    $: workDaysOfMonth = calcWorDaysOfMonth(daysOfMonth);
    $: selectedUser = findSelectedUser($users, bv_selected_user);
    function findSelectedUser() {
        if(!$users.length || !bv_selected_user) {
            return null;
        }
        const su = $users.find(_u => _u.id == parseInt(bv_selected_user));
        return su; 
    }

    $: usersWithContractInMonth = findUsersWithContractInMonth($users, bv_date);
    function findUsersWithContractInMonth() {
        let contracted_users = [];
        const month_time = new Date(bv_date).getTime();
        for(let i = 0; i < $users.length; i++) {
            const u = $users[i];
            if(!u?.contracts?.length || (u.contracts.find(_c => !_c.contract_end || (month_time > new Date(_c.contract_start).getTime() && month_time < new Date(_c.contract_end).getTime())))) {
                contracted_users.push($users[i]); 
            }
        } 

        return contracted_users;
    }



    /* HTML inserts */ 
    function userMonthlyHours(u) {
        const month_time = new Date(bv_date).getTime(); 
        const uc = u.contracts.find(_c => (month_time > new Date(_c.contract_start).getTime() && (month_time < new Date(_c.contract_end).getTime() || !_c.contract_end)));

        if(uc) {
            return uc.monthly_hours
                ? uc.monthly_hours
                : uc.dayli_hours * workDaysOfMonth;
        }

        if(u.contracts.length == 0) {
            return 0; 
        }

        return u.contracts[0].monthly_hours
            ? u.contracts[0].monthly_hours
            : u.contracts[0].dayli_hours * workDaysOfMonth; 
    } 


    function calcWorDaysOfMonth() {
        let sum_work_days = 0; 
        for(let i = 0; i < daysOfMonth.length; i++) {
            const d = new Date(daysOfMonth[i]); 
            if(d.getDay() != 0 && d.getDay() != 6) {
                sum_work_days += 1;
            }
        }

        return parseInt(sum_work_days); 
    }


    function contractModalHidden() {
        uikit.modal('#m_user').show();
    }


    function calcWorkedMinutes() {
        let sum_minutes = 0;
        for(let i = 0; i < user_month_days.length; i++) {
            sum_minutes += user_month_days[i].minutes_worked; 
        }
        return sum_minutes; 
    }


    function userSumMinues(u) {
        let sum_minutes = 0;
        const arr_user_month_days = $users.find(_u => _u.id == u.id).days; 
        for(let i = 0; i < arr_user_month_days.length; i++) {  
            if(arr_user_month_days[i].vacation_day) {
                sum_minutes += (60 * u.contracts.find(c => c.active == true).holiday_hours);  
            } else {
                sum_minutes += arr_user_month_days[i].minutes_worked; 
            }            
        }
        return sum_minutes; 
    }


    function findUserMonth(_u) {
        const u = $users.find(u => u.id == _u.id);
        if(u) {
            const um = u.user_months.find(um => date('Y-m', new Date(um.month_date)) == date('Y-m', new Date(bv_date))) 
            if(um) {
                return um;
            }
        }
        return null;
    }


    function getDatesOfCurrentMonth() {
        const now = new Date(bv_date);
        const year = now.getFullYear();
        const month = now.getMonth();
        const num_days = new Date(year, month + 1, 0).getDate();

        const dates = [];
        for(let day = 1; day <= num_days; day++) {
            const date = new Date(year, month, day);
            dates.push(date);
        }

        return dates;
    }



    /* Events */
    function setUserBindings(u = null) {
        user_id = u ? u.id : ''; 
        bv_user_nr = u ? u.nr : ''; 
        bv_firstname = u ? u.firstname : '';
        bv_lastname = u ? u.lastname : '';

        bv_additional_holidays = 0;
        bv_overtime_hours_payed_out = 0;
        if(u) {
            const user_month = u.user_months.find(_um => date('Y-m', new Date(_um.month_date)) == date('Y-m', new Date(bv_date)))
            if(user_month) { 
                edit_user_month_id = user_month.id;  
                bv_additional_holidays = user_month.additional_holidays; 
                bv_overtime_hours_payed_out = user_month.overtime_hours_payed_out;
            }
        }

        if(u) {
            uikit.modal('#m_user_info').show(); 
        } else {
            uikit.modal('#m_user').show();
        }
    }


    function setContractBindings(c = null) {
        contract_id = c ? c.id : '';
        bv_contract_start = c ? date('Y-m-d', new Date(c.contract_start)) : '';
        bv_contract_end = c && c.contract_end? date('Y-m-d', new Date(c.contract_end)) : '';
        bv_default_break = c ? c.default_break : '';
        bv_yearly_holidays = c ? c.yearly_holidays : '';
        bv_start_holidays = c ? c.start_holidays : 0;
        bv_start_overtime = c ? c.start_overtime_min : 0;
        bv_holiday_hours = c ? c.holiday_hours : 0;
        bv_dayli_hours = c ? c.dayli_hours : ''; 
        bv_monthly_hours = c ? c.monthly_hours : '';

        uikit.modal('#m_contract').show();
    }


    function setDayBindings(day = null, date_entry = null, u = null) {
        // wenn benutzer an einem tag nicht eingestempelt hat, gibt es für diesen tag auch kein day entry in der db
        // console.log('setDayBindings');
        bv_day_vacation = false; 
        bv_day_case = '';
        bv_day_faz = false;
        bv_without_break = false;
        day_id = ''; 
        start_stamp = '';
        end_stamp = '';
        bv_time_clocked_in = '';
        bv_time_clocked_out = ''; 
        bv_start_location = '';
        bv_end_location = '';
        bv_time_clocked_in2 = '';
        bv_time_clocked_out2 = '';
        bv_start_location2 = '';
        bv_end_location2 = '';
        bv_day_note = ''; 
        if(day?.detail?.id) { 
            console.log('day?.detail')
            console.log(day.detail) 
            day_id = day?.detail?.id;
            day_date = date('d.m.Y', new Date(day?.detail?.start_time));
            day_user_id = u.id; 
            
            bv_time_clocked_in = day?.detail?.start_time ? date('H:i', new Date(day?.detail?.start_time)) : '';
            bv_time_clocked_out = day?.detail?.end_time ? date('H:i', new Date(day?.detail?.end_time)) : '';
            bv_day_vacation = day?.detail?.vacation_day ? true : false;
            bv_day_faz = day?.detail?.faz_day ? true : false;
            if(day?.detail?.vacation_day) {
                bv_day_case = 'vacation'; // werhmm
            }
            if(day?.detail?.faz_day) {
                bv_day_case = 'faz'; // werhmm
            } 
            if(day?.detail?.sick_day) {
                bv_day_case = 'sick_day'; // werhmm
            }
            if(day?.detail?.short_work) {
                bv_day_case = 'short_work'; // werhmm
            }
            bv_without_break = day?.detail?.without_break ? true : false;
            bv_start_location = day?.detail?.start_location ?? '';
            bv_end_location = day?.detail?.end_location ?? '';
            start_stamp = day?.detail?.start_stamp 
                ? date('H:i', new Date(day?.detail?.start_stamp))
                : bv_time_clocked_in
            end_stamp = day?.detail?.end_stamp 
                ? date('H:i', new Date(day?.detail?.end_stamp))
                : bv_time_clocked_out

            bv_time_clocked_in2 = day?.detail?.start_time2 ? date('H:i', new Date(day?.detail?.start_time2)) : '';
            bv_time_clocked_out2 = day?.detail?.end_time2 ? date('H:i', new Date(day?.detail?.end_time2)) : '';
            bv_start_location2 = day?.detail?.start_location2 ?? '';
            bv_end_location2 = day?.detail?.end_location2 ?? '';
            bv_day_note = day?.detail?.note ?? '';
        } else {
            day_date = date('d.m.Y', new Date(date_entry));
            day_user_id = u.id;
        }
        uikit.modal('#m_day').show();
    }

    
    function changeMonth(inc) { 
        const d = new Date(bv_date);
        d.setMonth(d.getMonth() + inc);
        bv_date = date('Y-m-d', new Date(d));  
    } 


    function editNote(clicked_date, clicked_day = null) {
        bv_day_note = clicked_day?.detail?.note ?? '';
        bv_start_work = clicked_day?.detail?.start_time ?? '';
        bv_end_work = clicked_day?.detail?.end_time ?? ''; 
        bv_start_location = clicked_day?.detail?.start_location ?? '';
        bv_end_location = clicked_day?.detail?.end_location ?? '';
        bv_clicked_date = clicked_date;
        uikit.modal('#m_note').show();
    }



    /* GET */
    async function getUsersWithMonthDays() {
        if($user.admin) {
            admin_overview_loaded = false;
            const [data, error] = await request(`${$url}/user/all_with_month_days`, {
                date: bv_date
            });
            if(!error) {
                $users = data; 
                setTimeout(() => {
                   admin_overview_loaded = true;
                }, 10)
            }
        } 
    }


    async function getUserDaysOfCurrentMonth() {
        clearTimeout(gudocm); // getUserDaysOfCurrentMonth
        user_month_days = [];
        setTimeout(async () => { 
            const [data, error] = await request(`${$url}/user/days_of_month`, {
                date: bv_date
            });  
            if(!error) {
                user_month_days = data;
            }
        }, 10);
    }

 
    async function userCalc() { 
        const [data, error] = await request(`${$url}/user/calc_user_total_hours_and_holidays/${user_id}`);
        if(!error) {
            if($user.superuser) {
                successNotification('current user overtime: ' + data); 
            }            
        }
    }


    async function recalculateMonth(u) {
        const [data, error] = await request(`${$url}/user/calc_user_month/${u.id}/${bv_date}`);
        console.log('recalculateMonth')
        console.log(data)
        getUsersWithMonthDays(); 
    }


    async function exportPDF(nr = null) { 
        // window.location = 'https://zeiterfassung.ikb-technology.de/pdf/test';
        // request(`${$url}/pdf-month/${bv_user_nr}?date=${date('Y-m-d', new Date(bv_date))}`);  
        window.location = `${$url}/pdf-month/${nr ? nr : bv_user_nr}?date=${date('Y-m-d', new Date(bv_date))}`; 
    }



    /* POST */
    async function saveDay() {
        if(bv_day_vacation && bv_day_faz) {
            warningNotification($_('faz-and-vacation'));
        } else {
            const [data, error] = await request(`${$url}/day/admin_save`, {
                day_date: day_date,
                day_user_id: day_user_id, 
                nullable: true,
                time_clocked_in: bv_time_clocked_in,
                time_clocked_out: bv_time_clocked_out,
                time_clocked_in2: bv_time_clocked_in2,
                time_clocked_out2: bv_time_clocked_out2,
                day_id: day_id, // möglich, dass es keine daten für diesen tag gibt
                day_vacation: bv_day_vacation,
                day_case: bv_day_case,  
                faz_day: bv_day_faz,
                without_break: bv_without_break,
            });
            if(!error) { 
                user_id = day_user_id;
                successNotification($_('day-time-saved'));
                uikit.modal('#m_day').hide(); 
                getUsersWithMonthDays(); 
                // userCalc(); 
            }
        }        
    }


    async function saveUser() {
        const [data, error] = await request(`${$url}/user/admin_save/${user_id}`, {
            nr: bv_user_nr,
            firstname: bv_firstname,
            lastname: bv_lastname,
        });
        if(!error) { 
            successNotification($_('user-saved'));
            uikit.modal('#m_user').hide(); 
            getUsersWithMonthDays(); 
            // userCalc(); 
        }
    }


    async function saveContract() {
        const [data, error] = await request(`${$url}/user/save_contract/${contract_id}`, {
            contract_start: bv_contract_start, 
            yearly_holidays: bv_yearly_holidays,
            user_id: user_id,
            nullable: true,
            contract_end: bv_contract_end,
            default_break: bv_default_break, 
            dayli_hours: bv_dayli_hours,
            monthly_hours: bv_monthly_hours,
            start_holidays: bv_start_holidays, 
            start_overtime: bv_start_overtime, 
            holiday_hours: bv_holiday_hours,
        });
        if(!error) {
            successNotification($_('contract-saved'));
            uikit.modal('#m_contract').hide(); 
            getUsersWithMonthDays(); 
            // userCalc(); 
        }
    }


    async function saveUserMonth() {
        const [data, error] = await request(`${$url}/user/month/${edit_user_month_id}`, {
            nullable: true,
            additional_holidays: bv_additional_holidays,
            overtime_hours_payed_out: bv_overtime_hours_payed_out,
        }); 
        if(!error) {
            uikit.modal('#m_user_info').hide(); 
            successNotification('Änderungen gespeichert'); 
            getUsersWithMonthDays(); 
        }
    }



    /* UPDATE */
    async function updateDayNote() {     
        const location = await getLocation();
        const [data, error] = await request(`${$url}/day/update_note_date`, {
            user_id: bv_selected_user,
            day_date: date('d.m.Y', new Date(bv_clicked_date)),
            nullable: true,
            start_location: `${location[0]}_${location[1]}`,
            note: bv_day_note
        }); 
        if(!error) { 
            successNotification('Bemerkung gespeichert');
            uikit.modal('#m_note').hide();
            if($user.admin) {
                getUsersWithMonthDays(); 
            } else {
                getUserDaysOfCurrentMonth();
            }
        }
    }



    /* DELETE */
    async function removeDay() {
        const confirmed = await swalConfirm($_('remove-day'), $_('remove-day-confirm'), 'warning', $_('yes'));
        if(confirmed) {
            const [ data, error ] = await request(`${$url}/day/remove_user_day`, {
                day_date: day_date,
                day_user_id: day_user_id,
            });
            if(!error) {
                successNotification($_('day-tracking-removed'));
                uikit.modal('#m_day').hide();
                getUsersWithMonthDays();
            }
        } 
    }


</script>


<div class="uk-padding-small">

    {#if $user.admin}
        {#if daysOfMonth.length}
            <div uk-grid> 
                <div class="uk-width-1-2 uk-width-1-4@m">
                    <input type="date" class="uk-input uk-margin-top" bind:value={bv_date} />
                </div>
                {#if $view_width > 1300}
                    <div class="uk-width-1-2 uk-flex uk-flex-bottom uk-flex-center">
                        <h3 class="c-pointer">
                            <span uk-icon="icon:arrow-left;ratio:1.3" class="uk-margin-right" on:click={() => changeMonth(-1)}></span>

                            <span on:click={() => getUsersWithMonthDays()}>
                                {$_('month_' + (daysOfMonth[0].getMonth() + 1))} {daysOfMonth[0].getFullYear()}
                            </span>                        

                            <span uk-icon="icon:arrow-right; ratio:1.3" class="uk-margin-left" on:click={() => changeMonth(1)}></span>
                        </h3>                    
                    </div>
                    <div class="uk-width-1-4 uk-flex uk-flex-bottom">
                        <span> 
                            {$_('work-days-of-month')}: {workDaysOfMonth}
                        </span>
                    </div>
                {:else}
                    <div class="uk-width-1-2 uk-width-1-4@m">
                        <select class="uk-select uk-margin-top" bind:value={bv_selected_user}>
                            <option value="">{$_('select-employee')}</option>
                            <option value={$user.id}>
                                {$user.firstname} {$user.lastname}
                            </option>
                            {#each $users.filter(_u => _u.id != $user.id) as u}
                                <option value={u.id}>
                                    {u.firstname} {u.lastname}
                                </option>
                            {/each} 
                        </select>
                    </div>
                {/if}
            </div>
        {/if}
        {#if admin_overview_loaded}
            {#if $view_width > 1300}
                <table class="uk-table uk-table-small uk-animation-fade">
                    <thead> 
                        <tr>
                            <th style="width: 100px;"></th>
                            {#each daysOfMonth as date_entry}
                                <th class="uk-text-center uk-text-bold {date_entry.getDay() == 0 ? 'uk-text-danger' : ''}">
                                    {padNumber(date_entry.getDate())}
                                </th>
                            {/each}
                            <th>
                                {$_('sum')}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each usersWithContractInMonth as u}
                            <tr> 
                                <td class="uk-padding-remove" style="padding-bottom: 10px !important"> 
                                    <span on:click={() => setUserBindings(u)}>
                                        {u.firstname} {u.lastname.substr(0, 1)}.
                                    </span>
                                </td>
                                {#each daysOfMonth as date_entry}
                                    <td class="uk-padding-remove" style="padding-bottom: 10px !important"> 
                                        <UserDayTime admin={true} on:editDay={e => setDayBindings(e, date_entry, u)} {date_entry} {u} {yesterday} />
                                    </td>
                                {/each}
                                <td class="uk-padding-remove uk-text-right" style="padding-bottom: 10px !important"> 
                                    <span data-uk-tooltip="title: hh:mm" on:click={recalculateMonth(u)}>
                                        <!-- {userSumMinues(u)} -->
                                        {#if findUserMonth(u)?.month_worked_minutes !== null}
                                            {hhmm(findUserMonth(u)?.month_worked_minutes)} / {userMonthlyHours(u, bv_date).toFixed(1).toString().replace('.', ',')}
                                        {:else}
                                            {$_('no-data')}
                                        {/if}
                                    </span>

                                    <a uk-icon="download" on:click={() => exportPDF(u.nr)} style="color: white !important"></a>
                                </td>
                            </tr> 
                        {/each}
                    </tbody>
                </table> 
            {:else} 
                {#if selectedUser}
                    <ul class="uk-list uk-list-divider uk-margin-medium-bottom">
                        {#each daysOfMonth as date_entry}
                            <li> 
                                <span class="{date_entry.getDay() == 0 ? 'uk-text-danger' : ''}">
                                    <span class="uk-display-inline-block {date_entry.getDay() == 0 ? 'uk-text-danger' : ''}" style="width: 33px !important;">
                                        {$_('day_' + date_entry.getDay()).substr(0, 2)}.
                                    </span> 
                                    {date('d.m.', date_entry)}
                                </span>
                                <span class="uk-float-right">  
                                    {#if selectedUser.days.length}
                                        <UserDayTime on:editDay={e => editNote(date_entry, e)} {date_entry} u={selectedUser} {yesterday} user_month_days={selectedUser.days} admin={false} />
                                    {/if}
                                </span>
                            </li>
                        {/each}
                    </ul>
                {/if}
            {/if}
        {/if} 

        <button class="btn btn-default" on:click={() => setUserBindings()}>
            {$_('new-user')}
        </button>
        <!--
        <button class="btn btn-primary uk-float-right" on:click={() => exportPDF($user.nr)}>
            {$_('month-export')} 
        </button>
        -->
    {:else}
        <div uk-grid>
            <div class="uk-width-1-2">
                <input type="date" class="uk-input uk-margin-top" bind:value={bv_date} />
            </div>
            <div class="uk-width-1-2 uk-flex uk-flex-bottom uk-flex-right">
                <!-- {$_('monthly-hours-required')} --> 
                <span class="uk-margin-small-bottom uk-margin-right"> 
                    {hhmm(workedMinutes)} / 
                    {$user.contracts.find(c => c.active)?.monthly_hours ? parseInt($user.contracts.find(c => c.active)?.monthly_hours) : hhmm(workDaysOfMonth * $user.contracts.find(c => c.active)?.holiday_hours * 60)}
                    <!-- {$user.monthly_hours} -->
                </span>
            </div> 
        </div>
        <ul class="uk-list uk-list-divider uk-margin-medium-bottom">
            {#each daysOfMonth as date_entry}
                <li> 
                    <span class="{date_entry.getDay() == 0 ? 'uk-text-danger' : ''}">
                        <span class="uk-display-inline-block {date_entry.getDay() == 0 ? 'uk-text-danger' : ''}" style="width: 33px !important;">
                            {$_('day_' + date_entry.getDay()).substr(0, 2)}.
                        </span> 
                        {date('d.m.', date_entry)}
                    </span>
                    <span class="uk-float-right"> 
                        {#if user_month_days.length}
                            <UserDayTime on:editDay={e => editNote(date_entry, e)} {date_entry} u={$user} {yesterday} {user_month_days} admin={false} />
                        {/if}
                    </span>
                </li>
            {/each}
        </ul>
    {/if}


    <!-- Modals -->
    <div class="uk-modal-container" id="m_day" uk-modal>
        <div class="uk-modal-dialog">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-body">
                {#if $users.length}
                    <h3>{day_date} {$users.find(u => u.id == day_user_id)?.firstname ?? ''} {$users.find(u => u.id == day_user_id)?.lastname ?? ''}</h3>
                {/if} 
                <div uk-grid> 
                    <div class="uk-width-1-1">
                        {#if start_stamp && end_stamp}
                            <p>
                                Mitarbeit hat tatsächlich eingestempelt um: {!bv_day_vacation && !bv_day_faz ? start_stamp : ''}
                                und ausgestempelt um: {!bv_day_vacation && !bv_day_faz ? end_stamp : ''}
                            </p>
                        {/if}
                    </div>
                    <div class="uk-width-1-4">
                        <label>Sonderfall:</label> 
                        <select class="uk-select" bind:value={bv_day_case}>
                            <option value="">-</option>
                            <option value="vacation">{$_('vacation')}</option>
                            <option value="faz">Freizeitausgleich</option>
                            <option value="sick_day">Krank</option>
                            <option value="short_work">Witterungsbedingter Ausfall (WA)</option>
                            <!--
                            <option value="wa">Witterungsbedingter Ausfall (WA)</option>
                            -->
                        </select>
                    </div>
                    <!--
                    <div class="uk-width-1-4">
                        <label>
                            <input type="checkbox" class="uk-checkbox" bind:checked={bv_day_vacation} />
                            &nbsp;{$_('vacation')}
                        </label> 
                    </div>
                    <div class="uk-width-1-4">
                        <label>
                            <input type="checkbox" class="uk-checkbox" bind:checked={bv_day_faz} />
                            &nbsp;{$_('faz')}
                        </label>
                    </div>
                    -->
                    <div class="uk-width-3-4 uk-flex uk-flex-bottom">
                        <label class="uk-margin-small-bottom">
                            <input type="checkbox" class="uk-checkbox" bind:checked={bv_without_break} />
                            &nbsp;ohne Pause
                        </label>
                    </div>  
                    {#if bv_day_case != 'vacation' && bv_day_case != 'faz'}
                        <div class="uk-width-1-2 uk-margin-top">
                            <label>{$_('clocked-in')}: <span class="uk-text-danger">*</span></label>
                            <input type="time" class="uk-input" bind:value={bv_time_clocked_in} />
                        </div>
                        <div class="uk-width-1-2 uk-margin-top">  
                            <label>{$_('clocked-out')}: <span class="uk-text-danger">*</span></label>
                            <input type="time" class="uk-input" bind:value={bv_time_clocked_out} />
                        </div>
                    {/if} 

                    <div class="uk-width-1-2 uk-margin-top">
                        {#if bv_start_location}
                            {#key bv_start_location} 
                                <Map map_id={'clocked_in_map'} lat={bv_start_location.split('_')[0]} lng={bv_start_location.split('_')[1]} />
                            {/key}
                        {/if}
                    </div>
                    <div class="uk-width-1-2 uk-margin-top">
                        {#if bv_end_location} 
                            {#key bv_end_location}
                                <Map map_id={'clocked_out_map'} lat={bv_end_location.split('_')[0]} lng={bv_end_location.split('_')[1]} />
                            {/key} 
                        {/if}
                    </div>

                    <!-- zweite stempelung -->
                    {#if bv_day_case != 'vacation' && bv_day_case != 'faz'}
                        <div class="uk-width-1-2 uk-margin-top">
                            <label>{$_('clocked-in-again')}: <span class="uk-text-danger">*</span></label>
                            <input type="time" class="uk-input" bind:value={bv_time_clocked_in2} />
                        </div>
                        <div class="uk-width-1-2 uk-margin-top">  
                            <label>{$_('clocked-out-again')}: <span class="uk-text-danger">*</span></label>
                            <input type="time" class="uk-input" bind:value={bv_time_clocked_out2} />
                        </div>

                        <div class="uk-width-1-2 uk-margin-top"> 
                            {#if bv_start_location2} 
                                {#key bv_start_location2} 
                                    <Map map_id={'clocked_in2_map'} lat={bv_start_location2.split('_')[0]} lng={bv_start_location2.split('_')[1]} />
                                {/key}
                            {/if}
                        </div>
                        <div class="uk-width-1-2 uk-margin-top">
                            {#if bv_end_location2} 
                                {#key bv_end_location2}
                                    <Map map_id={'clocked_out2_map'} lat={bv_end_location2.split('_')[0]} lng={bv_end_location2.split('_')[1]} />
                                {/key} 
                            {/if}
                        </div>
                    {/if}

                    <p>
                        Bemerkung: {bv_day_note}
                    </p>

                    <div class="uk-width-1-1 uk-margin-top">
                        <button class="uk-button uk-button-danger" on:click={() => removeDay()}>
                            {$_('remove')} 
                        </button>
                        <button class="btn btn-primary uk-float-right" on:click={() => saveDay()}>
                            {$_('save')} 
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div id="m_user_info" uk-modal>
        <div class="uk-modal-dialog">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-body">
                <div uk-grid> 
                    <div class="uk-width-1-1">  
                        <h3>{bv_firstname} {bv_lastname}</h3> 
                        <div uk-grid>
                            <div class="uk-width-1-1">
                                <label>Zusätzlicher Urlaub diesen Monat: <span>*</span></label>
                                <input type="number" class="uk-input" bind:value={bv_additional_holidays} />
                            </div>
                            <div class="uk-width-1-1 uk-margin-top">
                                <label>Überstunden ausbezahl diesen Monat: <span>*</span></label>
                                <input type="number" class="uk-input" bind:value={bv_overtime_hours_payed_out} />
                            </div>
                            <div class="uk-width-1-1 uk-margin-top uk-flex uk-flex-center">
                                <button class="btn btn-primary" on:click={() => saveUserMonth()}>
                                    Speichern
                                </button>
                            </div>
                        </div>

                        <button class="btn btn-default uk-align-center" uk-toggle="target: #m_user">
                            {$_('edit-user')} 
                        </button>

                        <!--
                        <button class="btn btn-primary uk-float-right" on:click={() => exportPDF()}>
                            {$_('month-export')} 
                        </button> 
                        -->
                    </div>
                </div>
            </div>
        </div>
    </div> 

    <div id="m_user" class="uk-modal-container" uk-modal>
        <div class="uk-modal-dialog" style="min-width: 1600px;">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-body">
                <div uk-grid> 
                    <div class="uk-width-1-1 uk-width-1-4@m">  
                        <label>{$_('user-nr')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_user_nr} />
                    </div>
                    <div class="uk-width-1-1 uk-width-1-4@m">  
                        <label>{$_('firstname')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_firstname} />
                    </div> 
                    <div class="uk-width-1-1 uk-width-1-4@m">  
                        <label>{$_('lastname')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_lastname} />
                    </div>
                    <div class="uk-width-1-1 uk-width-1-4@m">
                        <br>
                        <button class="btn btn-primary uk-float-right" on:click={() => saveUser()}>
                            {$_('save')} 
                        </button>
                    </div>

                    <div class="uk-width-1-2 uk-margin-top">  
                        <h3 class="uk-margin-top">
                            Verträge
                        </h3>
                    </div>

                    <!--
                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('contract-start')}: <span class="uk-text-danger">*</span></label>
                        <input type="date" class="uk-input" bind:value={bv_contract_start} />
                    </div> 
                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('contract-end')}: <span class="uk-text-danger">*</span></label>
                        <input type="date" class="uk-input" bind:value={bv_contract_end} />
                    </div> 

                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('default-break')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_default_break} />
                    </div>
                     <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('yearly-holidays')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_yearly_holidays} />
                    </div> 

                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('monthly-hours')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_monthly_hours} />
                    </div>
                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('dayli-hours')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_dayli_hours} />
                    </div>              

                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('start-holidays')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_start_holidays} />
                    </div>
                    <div class="uk-width-1-2 uk-margin-top">   
                        <label>{$_('start-overtime')} (min): <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_start_overtime} />
                    </div>    
                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('holiday-hours')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_holiday_hours} />
                    </div>       
                    -->             

                    {#if user_id}
                        <div class="uk-width-1-1 uk-margin-top">
                            <table class="uk-table" style="color: white;">
                                <thead>
                                    <tr> 
                                        <!--
                                        <th>
                                            aktiv
                                        </th>
                                        -->
                                        <th>
                                            start
                                        </th>
                                        <th>
                                            ende
                                        </th>
                                        <th>
                                            pause
                                        </th>
                                        <th>
                                            monat stunden
                                        </th>
                                        <th>
                                            tages stunden
                                        </th>
                                        <th>
                                            jahresurlaub
                                        </th>
                                        <th>
                                            urlaub stunden
                                        </th>
                                        <th>
                                            urlaubstage zu beginn
                                        </th>
                                        <th>
                                            üst zu beginn
                                        </th> 
                                        <th>

                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!--
                                        active
                                        contract_start
                                        contract_end
                                        default_break
                                        monthly_hours
                                        dayli_hours
                                        yearly_holidays
                                        holiday_hours
                                        start_holidays
                                        start_overtime_min
                                        user_id
                                    -->
                                    {#each $users.find(_u => _u.id == user_id).contracts.sort((a, b) => a.contract_end ? -1 : 1) as c}
                                        <tr>
                                            <!--
                                            <td> 
                                                {c.active ? 'ja' : 'nein'}
                                            </td>
                                            -->
                                            <td>
                                                {date('d.m.Y', new Date(c.contract_start))}
                                            </td>
                                            <td>
                                                {c.contract_end ? date('d.m.Y', new Date(c.contract_end)) : ''}
                                            </td>
                                            <td>
                                                {c.default_break}
                                            </td>
                                            <td>
                                                {c.monthly_hours} 
                                            </td>
                                            <td>
                                                {c.dayli_hours}
                                            </td>
                                            <td>
                                                {c.yearly_holidays}
                                            </td>
                                            <td>
                                                {c.holiday_hours}
                                            </td>
                                            <td>
                                                {c.start_holidays}
                                            </td>
                                            <td>
                                                {c.start_overtime_min}
                                            </td>
                                            <td style="min-width: 80px;">
                                                <span uk-icon="pencil" on:click={() => setContractBindings(c)}></span>
                                            </td>
                                        </tr>
                                    {/each}
                                </tbody> 
                            </table>
                        </div>

                        <div class="uk-width-1-1">
                            <button class="btn btn-primary uk-float-right" on:click={() => setContractBindings()}>
                                neuer contract
                            </button>
                        </div>


                    {/if}
                </div>
            </div>
        </div>
    </div>

    <div id="m_contract" uk-modal on:hidden={() => contractModalHidden()}>
        <div class="uk-modal-dialog">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-body">

                <div uk-grid>   
                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('contract-start')}: <span class="uk-text-danger">*</span></label>
                        <input type="date" class="uk-input" bind:value={bv_contract_start} />
                    </div> 
                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('contract-end')}: <span class="uk-text-danger">*</span></label>
                        <input type="date" class="uk-input" bind:value={bv_contract_end} />
                    </div> 

                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('default-break')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_default_break} />
                    </div>
                     <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('yearly-holidays')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_yearly_holidays} />
                    </div> 

                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('monthly-hours')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_monthly_hours} />
                    </div>
                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('dayli-hours')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_dayli_hours} />
                    </div>              

                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('start-holidays')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_start_holidays} />
                    </div>
                    <div class="uk-width-1-2 uk-margin-top">   
                        <label>{$_('start-overtime')} (min): <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_start_overtime} />
                    </div>    
                    <div class="uk-width-1-2 uk-margin-top">  
                        <label>{$_('holiday-hours')}: <span class="uk-text-danger">*</span></label>
                        <input type="text" class="uk-input" bind:value={bv_holiday_hours} />
                    </div>  
                    <div class="uk-width-1-1 uk-margin-top">
                        <button class="btn btn-primary uk-float-right" on:click={() => saveContract()}>
                            {$_('save')} 
                        </button> 
                    </div>
                </div>
            </div>  
        </div>  
    </div>

    <div id="m_note" uk-modal>
        <div class="uk-modal-dialog">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-body">

                <div uk-grid>   
                    <div class="uk-width-1-1">
                        <label>Bemerkung: </label> 
                        <textarea class="uk-textarea" rows="5" bind:value={bv_day_note}></textarea>
                        <button class="btn btn-primary uk-align-center" on:click={() => updateDayNote()}>{$_('save')}</button>
                    </div>

                    <div class="uk-width-1-1">
                        {#if bv_start_work && bv_end_work}
                            <p>
                                gearbeitet von: {date('H:i', new Date(bv_start_work))} Uhr bis: {date('H:i', new Date(bv_end_work))} Uhr
                            </p>
                        {/if}
                    </div> 
                    {#if $user.admin}
                        <div class="uk-width-1-2 uk-margin-top">
                            <label>Eingestempelt: </label>
                            {#if bv_start_location}
                                {#key bv_start_location} 
                                    <Map map_id={'clocked_in_map_note'} lat={bv_start_location.split('_')[0]} lng={bv_start_location.split('_')[1]} />
                                {/key}
                            {/if}
                        </div>

                        <div class="uk-width-1-2 uk-margin-top">
                            <label>Ausgestempelt: </label> 
                            {#if bv_end_location} 
                                {#key bv_end_location}
                                    <Map map_id={'clocked_out_map_note'} lat={bv_end_location.split('_')[0]} lng={bv_end_location.split('_')[1]} />
                                {/key} 
                            {/if}
                        </div>
                    {/if} 
                </div>
                
            </div>  
        </div>  
    </div>
</div>